module.exports = __webpack_public_path__ + "static/media/pn.6ed60308.svg";